const ACTION_PREPEND = 'customerRequest';
export const COMPLETE_CUSTOMER_REQUEST = `${ACTION_PREPEND}/COMPLETE_CUSTOMER_REQUEST`;
export const COMPLETING_CUSTOMER_REQUEST = `${ACTION_PREPEND}/COMPLETING_CUSTOMER_REQUEST`;
export const CUSTOMER_VERIFIED_DOCUMENT = `${ACTION_PREPEND}/CUSTOMER_VERIFIED_DOCUMENT`;
export const CUSTOMER_REQUEST_DOCUMENT_SELECTED = `${ACTION_PREPEND}/CUSTOMER_REQUEST_DOCUMENT_SELECTED`;
export const FETCH_CUSTOMER_REQUEST_DOCUMENTS = `${ACTION_PREPEND}/FETCH_CUSTOMER_REQUEST_DOCUMENTS`;
export const OPEN_AND_SAVE_PLAID = `${ACTION_PREPEND}/OPEN_AND_SAVE_PLAID`;
export const PASSED_VALIDATION = `${ACTION_PREPEND}/PASSED_VALIDATION`;
export const REQUEST_DOCUMENT_CHANGED = `${ACTION_PREPEND}/REQUEST_DOCUMENT_CHANGED`;
export const RESET_CUSTOMER_REQUEST = `${ACTION_PREPEND}/RESET_CUSTOMER_REQUEST`;
export const RESET_CUSTOMER_REQUEST_TOAST = `${ACTION_PREPEND}/RESET_CUSTOMER_REQUEST_TOAST`;
export const SET_CUSTOMER_REQUEST_TOAST = `${ACTION_PREPEND}/SET_CUSTOMER_REQUEST_TOAST`;
export const SELECTED_CUSTOMER_REQUEST = `${ACTION_PREPEND}/SELECTED_CUSTOMER_REQUEST`;
export const UPLOADING_DOCUMENT = `${ACTION_PREPEND}/UPLOADING_DOCUMENT`;
export const UPLOADING_REQUEST_DOCUMENTS = `${ACTION_PREPEND}/UPLOADING_REQUEST_DOCUMENTS`;
export const VERIFICATIONS_FETCH = `VERIFICATIONS_FETCH`;
export const COMPLETE_ALL_PLAID_CUSTOMER_REQUESTS = 'COMPLETE_ALL_PLAID_CUSTOMER_REQUESTS';
